document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById('image-modal');
  const modalImage = document.getElementById('modal-image');
  const modalSize = document.getElementById('modal-size');
  const modalMaterial = document.getElementById('modal-material');

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      const handle = el.dataset.handle;
      observer.unobserve(el);

      fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((data) => {
          const variant = data.variants[0];
          const baseImg = data.featured_image;
          const smallImg = baseImg.replace(/(\.(jpg|jpeg|png|webp))$/, '_100x100_crop_center$1');

          const image = el.querySelector(".variant-thumbnail");
          image.src = smallImg;
          image.setAttribute("data-full-image", baseImg);
          image.setAttribute("alt", data.title);

          el.querySelector(".product__title").textContent = data.type || data.title;

          const priceEl = el.querySelector(".current_price");
          const formEl = el.querySelector(".product_form_multi");

          if (!variant.available) {
            priceEl.textContent = "Sold Out";
            priceEl.classList.add("sold-out");
            if (formEl) formEl.style.display = "none";
          } else {
            priceEl.textContent = formatter.format(variant.price / 100);
            el.querySelector(".variant_id").value = variant.id;
            if (formEl) formEl.style.display = "flex";
          }

          const size = data?.metafields?.custom?.individual_size || variant?.metafields?.custom?.individual_size;
          const material = data?.metafields?.my_fields?.material2 || variant?.metafields?.my_fields?.material2;

          if (size) {
            el.dataset.individualSize = size;
          }
          if (material) {
            el.dataset.material2 = material;
          }
        })
        .catch((err) => {
          el.querySelector(".product__title").textContent = "Error loading product";
          console.error("Failed to load product", handle, err);
        });
    });
  }, {
    rootMargin: "100px",
    threshold: 0.1,
  });

  document.querySelectorAll(".configurations__item").forEach((el) => observer.observe(el));

  // Event delegation for dynamically updated images
  document.querySelector('.product-family')?.addEventListener('click', function (e) {
    const img = e.target.closest('.variant-thumbnail');
    if (!img) return;

    const wrapper = img.closest('.configurations__item');
    if (!wrapper) return;

    const fullSrc = img.getAttribute('data-full-image');
    const individualSize = wrapper.dataset.individualSize || "No size specified.";
    const material2 = wrapper.dataset.material2 || "No material info.";

    modalImage.src = fullSrc;
    modalSize.textContent = `Size: ${individualSize}`;
    modalMaterial.textContent = `Material: ${material2}`;
    modal.classList.remove('hidden');
    modal.focus();
  });

  modal.addEventListener('click', function () {
    modal.classList.add('hidden');
    modalImage.src = '';
    modalSize.textContent = '';
    modalMaterial.textContent = '';
  });

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("qty-btn")) {
      const input = e.target.closest(".product_form_multi")?.querySelector(".configuration__quantity");
      let current = parseInt(input.value, 10) || 0;

      if (e.target.classList.contains("plus")) {
        input.value = current + 1;
      } else if (e.target.classList.contains("minus") && current > 0) {
        input.value = current - 1;
      }
    }
  });

  document.querySelectorAll(".multi_add_to_cart").forEach((button) => {
    button.addEventListener("click", () => {
      const queue = [];
      let hasQty = false;

      document.querySelectorAll(".product_form_multi").forEach((form) => {
        const qtyInput = form.querySelector(".configuration__quantity");
        const qty = parseInt(qtyInput.value, 10);
        if (qty > 0) {
          hasQty = true;
          const variantId = form.querySelector(".variant_id").value;
          queue.push({ id: variantId, quantity: qty });
        }
      });

      const errorBox = document.getElementById("family-error");

      if (!hasQty) {
        errorBox.style.display = "block";
        return;
      } else {
        errorBox.style.display = "none";
      }

      const moveAlong = () => {
        if (!queue.length) {
          document.getElementById("family-status").style.display = "block";
          document.querySelectorAll(".configuration__quantity").forEach(input => input.value = 0);

          if (window.Shopify?.theme?.cartDrawer?.open) {
            Shopify.theme.cartDrawer.open();
          } else {
            document.dispatchEvent(new Event("cart:refresh"));
            window.location.href = "/cart";
          }
          return;
        }

        const item = queue.shift();
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        })
        .then(() => moveAlong())
        .catch((err) => {
          console.error("Add to cart error:", err);
          moveAlong();
        });
      };

      moveAlong();
    });
  });
});
